import * as React from 'react';
import * as advantage from './style.module.scss';
import { advantageData } from './advantageData';
export const Advantage = ({ data=advantageData }) => {
  return (
    <section className={advantage.advantage}>
      <div className="container">
        <ul className={advantage.advantage__list}>
          {
            data.map((elem, index) => (
              <li className={advantage.advantage__item} key={index}>
                <p className={advantage.advantage__description}>
                  {elem.description}
                </p>
              </li>
            ))
          }
        </ul>
      </div>
    </section>
  );
};
